import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { FooterBaseComponent } from '@technocom/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent extends FooterBaseComponent {
  constructor(private router: Router) {
    super();
  }

  onSupportButtonClick(): void {
    this.router.navigateByUrl('/feedback');
  }
}
